// extracted by mini-css-extract-plugin
export default {"header":"SearchResultsBottomSheet_header__o6wZc","entitiesContainer":"SearchResultsBottomSheet_entitiesContainer__NDXUI"};